export default __webpack_public_path__ + "static/media/SFTSchriftedSansTRIAL-Bold-BF6413e20329194.b0e7ddf2.ttf";